import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCardMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "credit-card-mastercard_icon",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M21.913 3.5H2.087A2.05 2.05 0 0 0 0 5.5v13a2.05 2.05 0 0 0 2.087 2h19.826a2.05 2.05 0 0 0 2.087-2v-13a2.05 2.05 0 0 0-2.087-2m-6.842 14.179a5.13 5.13 0 0 1-3.171-1.112.25.25 0 0 0-.309 0 5.1 5.1 0 0 1-3.165 1.112 5.179 5.179 0 0 1 0-10.358A5.1 5.1 0 0 1 11.6 8.434a.25.25 0 0 0 .308 0 5.13 5.13 0 0 1 3.168-1.112 5.179 5.179 0 0 1 0 10.358Z" }), /* @__PURE__ */ _jsx("path", { d: "M18.75 12.5a3.683 3.683 0 0 0-3.679-3.679 3.6 3.6 0 0 0-2.127.714.25.25 0 0 0-.067.33 5.12 5.12 0 0 1 0 5.27.25.25 0 0 0 .067.33 3.6 3.6 0 0 0 2.127.714A3.683 3.683 0 0 0 18.75 12.5" })]
});
export { SvgCreditCardMastercard as ReactComponent };
